// Types
import type { NotificationUsersAndRolesProps } from '@/utils/hooks/context/toast/types';

// Utils
import { USERS_ROLES } from '@/lib/routes/privateRoutes';

// Component
import Notification from '@/components/base/Notification';

const NewUserInvitationByManager = ({ notification }: NotificationUsersAndRolesProps) => {
    return (
        <Notification
            dataNotification={notification}
            goToUrl={USERS_ROLES}
            contentHidden={notification?.options?.hideContent ?? false}
            wide={notification?.options?.wide ?? true}>
            <Notification.Icon icon="users-roles" />
            <Notification.Content>
                <Notification.Title i18nKey="commons:notifications.user_invitation_by_manager.title" />
                <Notification.Description
                    i18nKey="commons:notifications.user_invitation_by_manager.description"
                    values={{
                        username: notification?.data?.invited_user_name,
                        manager_username: notification?.data?.manager_user_name
                    }}
                />
            </Notification.Content>
        </Notification>
    );
};

export default NewUserInvitationByManager;
